import { useFetcher } from 'react-router-dom'
import { type Project } from 'api-client'

import { useProjectIdParam } from '~/entities/projects'

import { Loading } from '~/components/Loading'
import { Message } from '~/components/Message'
import { Stack } from '~/components/Stack'
import { Switch } from '~/components/Switch'

import { useQrynDrilldown } from '../model'

type ManageQrynDrilldownSwitcherProps = {
  projectId: Project['id']
  projectSlug: Project['slug']
}

export function ManageQrynDrilldownSwitcher({ projectId }: ManageQrynDrilldownSwitcherProps) {
  const { projectSlug } = useProjectIdParam()
  const fetcher = useFetcher()

  const { drilldownEnabled, handleDrilldownToggle } = useQrynDrilldown({ projectSlug, projectId })

  return (
    <Stack space="small">
      <Switch
        isSelected={drilldownEnabled}
        isDisabled={fetcher.state !== 'idle'}
        onChange={(enabled: boolean) => {
          handleDrilldownToggle(enabled)
        }}
      >
        {fetcher.state === 'submitting' && <Loading />}
        drilldown support
      </Switch>

      <Message type="warning" size="small">
        This option allows you to enable/disable drilldown usage on the server side
      </Message>
    </Stack>
  )
}
